import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { authFetch, API } from '../api';

// Settings → HRX & Bring (guided P&P phase 7, 2026-10-17; backend/hrx_send.py): the sending side — our HRX days, the
// rule (parcels per country, countries, how long parcels may wait), the forecast's packing hours. Since 5.11 the HRX
// schedule itself (HRX's e-mails, the day types' times, the mailbox switch) is its own section: Settings → HRX schedule.

const card = 'bg-[#1a1d27] rounded-xl border border-gray-800 p-5';
const head = 'text-gray-400 text-xs uppercase tracking-widest font-semibold mb-3';
const input = 'px-2 py-1 rounded bg-[#0f1117] border border-gray-700 text-white text-sm';
const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

export default function HrxSettings() {
  const [pol, setPol] = useState<any>(null);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const load = () => authFetch(`${API}/settings/hrx`).then(async r => {
    const d = await r.json().catch(() => ({} as any));
    if (!r.ok) { setErr(d.detail || `HTTP ${r.status}`); return; }
    setPol(d.policy);
  });
  useEffect(() => { load(); }, []);
  if (!pol) return <div className="text-gray-400 text-sm">{err || 'Loading…'}</div>;

  const save = async () => {
    setErr(''); setMsg('');
    const body = { weekdays: pol.weekdays, min_per_country: pol.min_per_country, min_countries: pol.min_countries,
                   max_wait_workdays: pol.max_wait_workdays, orders_per_hour: pol.orders_per_hour, packing_hours: pol.packing_hours };
    const r = await authFetch(`${API}/settings/hrx`, { method: 'PUT', body: JSON.stringify(body) });
    const d = await r.json().catch(() => ({} as any));
    if (!r.ok) { setErr(d.detail || `HTTP ${r.status}`); return; }
    setPol(d); setMsg('✓ Saved');
  };

  return (
    <div className="space-y-6">
      {msg && <div className="text-green-400 text-sm">{msg}</div>}
      {err && <div className="text-red-400 text-sm">{err}</div>}
      <div className="text-sm text-gray-400">HRX's own ship days and times are in <Link to="/settings/hrx-schedule" className="text-blue-400 hover:underline">Settings → HRX schedule</Link>.</div>
      <div className={card}>
        <div className={head}>Our HRX days and the rule</div>
        <div className="flex flex-wrap gap-3 mb-3">
          {DAYS.map(d => (
            <label key={d} className="flex items-center gap-1 text-sm text-gray-200">
              <input type="checkbox" checked={!!pol.weekdays[d]} onChange={e => setPol({ ...pol, weekdays: { ...pol.weekdays, [d]: e.target.checked } })} />
              {d.charAt(0).toUpperCase() + d.slice(1)}</label>
          ))}
        </div>
        <div className="flex flex-wrap gap-4 text-sm text-gray-300">
          {[['min_per_country', 'parcels per country'], ['min_countries', 'countries'], ['max_wait_workdays', 'max workdays waiting'],
            ['orders_per_hour', 'orders packed per hour (forecast)']].map(([k, l]) => (
            <label key={k}>{l} <input value={pol[k]} onChange={e => setPol({ ...pol, [k]: e.target.value.replace(/\D/g, '') })}
              className={`${input} keep-width w-16 ml-1`} /></label>
          ))}
        </div>
        <div className="mt-4 text-sm text-gray-300">
          <div className="text-gray-400 mb-1">Packing hours — the forecast counts only these minutes before "goods ready" (empty = no packing that day)</div>
          <div className="flex flex-wrap gap-x-5 gap-y-1">
            {DAYS.map(d => {
              const w: string[] | null = pol.packing_hours?.[d] || null;
              const set = (i: number, v: string) => {
                const n = [...(w || ['', ''])]; n[i] = v;
                setPol({ ...pol, packing_hours: { ...pol.packing_hours, [d]: n[0] || n[1] ? n : null } });
              };
              return (
                <label key={d} className="flex items-center gap-1">
                  <span className="w-9">{d.charAt(0).toUpperCase() + d.slice(1)}</span>
                  <input value={w?.[0] || ''} onChange={e => set(0, e.target.value)} placeholder="—" className={`${input} keep-width w-16`} />
                  –<input value={w?.[1] || ''} onChange={e => set(1, e.target.value)} placeholder="—" className={`${input} keep-width w-16`} />
                </label>
              );
            })}
          </div>
        </div>
        <button onClick={save} className="mt-4 px-4 py-1.5 rounded bg-blue-600 hover:bg-blue-500 text-white text-sm">Save</button>
      </div>
    </div>
  );
}
